export const EVENT_LOGGING_OPTIONS_ENUM = Object.freeze({
  NONE: "none",
  EFFORTLESS: "effortless",
  MANUAL: "manual",
})
